var _path, _path2, _path3, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03479 11.1306C1.10847 9.92173 1.14531 9.31731 1.45854 8.73597C1.74473 8.20481 2.2923 7.6896 2.83988 7.43625C3.43921 7.15897 4.12617 7.15897 5.50008 7.15897C6.01215 7.15897 6.26819 7.15897 6.5162 7.11709C6.76138 7.07568 7.00046 7.00396 7.22795 6.90356C7.45806 6.80201 7.67181 6.66107 8.09932 6.3792L8.31825 6.23484C10.8612 4.55816 12.1327 3.71981 13.2001 4.08405C13.4047 4.15388 13.6028 4.25469 13.7797 4.37901C14.7024 5.02747 14.7725 6.53617 14.9127 9.55358C14.9646 10.6708 15 11.6271 15 12.159C15 12.6909 14.9646 13.6471 14.9127 14.7644C14.7725 17.7818 14.7024 19.2905 13.7797 19.9389C13.6028 20.0632 13.4047 20.1641 13.2001 20.2339C12.1327 20.5981 10.8612 19.7598 8.31825 18.0831L8.09932 17.9387C7.67181 17.6569 7.45806 17.5159 7.22795 17.4144C7.00046 17.314 6.76138 17.2423 6.5162 17.2008C6.26819 17.159 6.01215 17.159 5.50008 17.159C4.12617 17.159 3.43921 17.159 2.83988 16.8817C2.2923 16.6283 1.74473 16.1131 1.45854 15.582C1.14531 15.0006 1.10847 14.3962 1.03479 13.1874C1.01299 12.8298 1 12.4814 1 12.159C1 11.8366 1.01299 11.4882 1.03479 11.1306Z",
    stroke: "#9EA0A2",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6.15918C19.5 6.15918 21 7.95918 21 12.1592C21 16.3592 19.5 18.1592 19.5 18.1592",
    stroke: "#9EA0A2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.15918C17.5 9.15918 18 10.0592 18 12.1592C18 14.2592 17.5 15.1592 17.5 15.1592",
    stroke: "#9EA0A2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.55279,
    y1: 20.7764,
    x2: 15.5528,
    y2: 0.776394,
    stroke: "#9EA0A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/volumeMute.b206e22ceb1bb3998e40cd659fc342e5.svg";
export { ForwardRef as ReactComponent };